import { Cloudinary } from "cloudinary-core"; //
let cloudinarySdk: Cloudinary = null;

export function initializeCloadinarySdk(accountName: string) {
    cloudinarySdk = new Cloudinary({
        cloud_name: accountName,
        secure: true
    });
    return cloudinarySdk;
}

export function getImageThumbnail(url: string): string {
    return cloudinarySdk.url(url, {
        secure: true,
        height: 300,
        crop: "fill",
        width: 300,
        type: "fetch"
    });
}
